import { useQuery } from "@apollo/client";
import React, { useContext, useEffect, useRef, useState } from "react";
import { GET_VENDOR_TRANSACTION } from "../../../Qurries";
// "../../../../Qurries";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import {
  Table,
  Pagination,
  RowsPerPageSelect,
} from "../../../components/Table";
import { amountFormat } from "../../../utils/amountFormat";
import { formatDate } from "../Transaction/components/TransactionDateFilter";
import { CustomDropdownIndicator } from "../Settlement/Settlement";
import Select from "react-select";
import { endOfDay, startOfDay } from "date-fns";
import { HiMiniXMark } from "react-icons/hi2";
import { getStartAndEndOfMonth } from "../../../utils/getStartDateAndEndDate";
import { Link, useLocation } from "react-router-dom";
import { payment_method_map } from "../Transaction/Transaction";
import { IoSearchOutline } from "react-icons/io5";
import MixFilter from "../Transaction/components/MixFilter";
import { getPaymentMode } from "../../../utils/getPaymentMode";
import DateFilter from "../Refund/DateFilter";
import axios from "axios";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { dashboardContext } from "../Dashboard";
import { usePaymentUrlFilters } from "../../../hooks/usePaymentUrlFilters";
import { getActiveCheckboxKeys, parseDateParam, serializeCommaList } from "../../../utils/paymentUrlFilters";

function VendorTransaction() {
  const { get, getNumber, getBoolean, updateParams } = usePaymentUrlFilters();
  const location = useLocation();
  const skipUrlSyncRef = useRef(true);
  const returnPath = `${location.pathname}${location.search}`;

  const [searchText, setSearchText] = useState<any>(() => get("search"));
  const [currentPage, setCurrentPage] = useState(() => getNumber("page", 1));
  const [itemsPerRow, setItemsPerRow] = useState({
    name: getNumber("limit", 10),
  });
  const [shouldSearch, setShouldSearch] = useState(() => Boolean(get("search")));
  const [TotalPages, setTotalPages] = useState(0);
  const urlStartDate = parseDateParam(get("start_date"));
  const urlEndDate = parseDateParam(get("end_date"));
  const [selectedRange, setSelectedRange] = useState({
    startDate: urlStartDate || new Date(),
    endDate: urlEndDate || new Date(),
    key: "selection",
  });
  const [type, setType] = useState(() => get("filter_type"));
  const [dateRange, setDateRange] = useState(() => get("date_range", "Today"));
  const [transactionData, setTransactionData] = useState<any>([]);
  const [isDateRangeIsSelected, setIsDateRangeIsSelected] = useState(() =>
    getBoolean("custom_date"),
  );
  const [status, setStatus] = useState<any>(() => get("status") || null);
  const [schoolId, setSchoolId] = useState<string>("");
  const [tempschoolId, tempsetSchoolId] = useState<string>("");
  const [selectSchool, setSelectSchool] = useState("");
  const [tempselectSchool, settempSelectSchool] = useState("");
  // const [refetching, setRefetching] = useState(false);
  const todayRange = {
    startDate: startOfDay(new Date()),
    endDate: endOfDay(new Date()),
  };

  const startDate = formatDate(todayRange.startDate);
  const endDate = formatDate(todayRange.endDate);
  const [searchFilter, setSearchFilter] = useState<any>(() =>
    get("search_filter"),
  );
  const [vendorAmountDetails, setVendorAmountDetails] = useState<any>(null);
  const { user } = useContext(dashboardContext);
  const paymentModesFromUrl = (get("payment_modes") || "").split(",").filter(Boolean);
  const gatewaysFromUrl = (get("gateway") || "").split(",").filter(Boolean);
  
  const [filters, setFilters] = useState<any>({
    paymentMode: {
      credit_card: paymentModesFromUrl.includes("credit_card"),
      credit_card_emi: paymentModesFromUrl.includes("credit_card_emi"),
      upi: paymentModesFromUrl.includes("upi"),
      wallet: paymentModesFromUrl.includes("wallet"),
      pay_later: paymentModesFromUrl.includes("pay_later"),
      cardless_emi: paymentModesFromUrl.includes("cardless_emi"),
      net_banking: paymentModesFromUrl.includes("net_banking"),
      debit_card_emi: paymentModesFromUrl.includes("debit_card_emi"),
      debit_card: paymentModesFromUrl.includes("debit_card"),
      na: paymentModesFromUrl.includes("na"),
      qr: paymentModesFromUrl.includes("qr"),
      vba: paymentModesFromUrl.includes("vba"),
      pos_credit_card: paymentModesFromUrl.includes("pos_credit_card"),
      pos_debit_card:paymentModesFromUrl.includes("pos_debit_card"),
      pos_qr:paymentModesFromUrl.includes("pos_qr"),
      cash: paymentModesFromUrl.includes("cash"),
    },
    gateway: {
      EDVIRON_PG: gatewaysFromUrl.includes("EDVIRON_PG"),
      EDVIRON_EASEBUZZ: gatewaysFromUrl.includes("EDVIRON_EASEBUZZ"),
      EDVIRON_RAZORPAY: gatewaysFromUrl.includes("EDVIRON_RAZORPAY"),
      PHONEPE: gatewaysFromUrl.includes("PHONEPE"),
      HDFC: gatewaysFromUrl.includes("HDFC"),
      EDVIRON_PAY_U: gatewaysFromUrl.includes("EDVIRON_PAY_U"),
      EDVIRON_CCAVENUE: gatewaysFromUrl.includes("EDVIRON_CCAVENUE"),
      EDVIRON_HDFC_RAZORPAY: gatewaysFromUrl.includes("EDVIRON_HDFC_RAZORPAY"),
      EDVIRON_NTTDATA: gatewaysFromUrl.includes("EDVIRON_NTTDATA"),
      EDVIRON_WORLDLINE: gatewaysFromUrl.includes("EDVIRON_WORLDLINE"),
    },
    vendor_id: get("vendor_id"),
  });
  const [tempFilters, setTempFilters] = useState(filters);

  const {
    // data,
    loading,
    // refetch,
  } = useQuery(GET_VENDOR_TRANSACTION, {
    onCompleted(data) {
      setTransactionData(
        data?.getMerchantVendorTransaction?.vendorsTransaction,
      );
      setTotalPages(data?.getMerchantVendorTransaction?.totalPages);
    },
    onError() {
      setTransactionData([]);
      setTotalPages(0);
    },
    variables: {
      page: currentPage,
      limit: itemsPerRow.name,
      startDate: isDateRangeIsSelected
        ? formatDate(selectedRange.startDate)
        : startDate,
      endDate: isDateRangeIsSelected
        ? formatDate(selectedRange.endDate)
        : endDate,
      status: status,
      vendor_id: filters.vendor_id ? filters.vendor_id : undefined,
      order_id: shouldSearch && searchFilter === "order_id" ? searchText : null,
      custom_id:
        shouldSearch && searchFilter === "custom_order_id" ? searchText : null,
      payment_modes: getPaymentMode(filters.paymentMode, type),
      isQrCode: getPaymentMode(filters.paymentMode, type)?.includes("qr"),
      gateway: getPaymentMode(filters.gateway, type),
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    skipUrlSyncRef.current = false;
  }, []);

  useEffect(() => {
    if (skipUrlSyncRef.current) return;

    const paymentModes = getActiveCheckboxKeys(filters.paymentMode);
    const gateways = getActiveCheckboxKeys(filters.gateway);

    updateParams({
      page: currentPage > 1 ? currentPage : null,
      limit: itemsPerRow.name !== 10 ? itemsPerRow.name : null,
      search: shouldSearch && searchText ? searchText : null,
      search_filter: searchFilter || null,
      status: status || null,
      start_date: isDateRangeIsSelected
        ? formatDate(selectedRange.startDate)
        : null,
      end_date: isDateRangeIsSelected
        ? formatDate(selectedRange.endDate)
        : null,
      vendor_id: filters.vendor_id ? filters.vendor_id : undefined,
      payment_modes: serializeCommaList(paymentModes) || null,
      gateway: serializeCommaList(gateways) || null,
      custom_date: isDateRangeIsSelected ? true : null,
      date_range: dateRange !== "Today" ? dateRange : null,
      filter_type: type || null,
    });
  }, [
    currentPage,
    itemsPerRow.name,
    searchText,
    searchFilter,
    shouldSearch,
    status,
    isDateRangeIsSelected,
    selectedRange.startDate,
    selectedRange.endDate,
    dateRange,
    type,
    updateParams,
    filters
  ]);

  const getVendorReceiptState = (transaction: any) => ({
    collect_id: transaction?.collect_id.toString(),
    amount: transaction?.amount,
    schoolName: transaction?.name,
    from: returnPath,
  });

  // const refetchDataFetch = async ({
  //   start_date,
  //   end_date,
  //   page,
  //   status,
  //   vendor_id,
  //   custom_id,
  //   order_id,
  //   payment_modes,
  //   isQrCode,
  //   gateway,
  // }: {
  //   start_date?: any;
  //   end_date?: any;
  //   page?: String;
  //   status?: String;
  //   vendor_id?: string;
  //   limit?: String;
  //   custom_id?: string;
  //   payment_modes?: string[] | null;
  //   order_id?: string;
  //   isQrCode?: boolean;
  //   gateway?: string[] | null;
  // }) => {
  //   try {
  //     setRefetching(true);
  //     const data = await refetch({
  //       endDate: end_date,
  //       startDate: start_date,
  //       page: currentPage,
  //       limit: itemsPerRow.name,
  //       status,
  //       vendor_id,
  //       custom_id,
  //       order_id,
  //       payment_modes: isQrCode ? null : payment_modes,
  //       isQRCode: isQrCode,
  //       gateway,
  //     });
  //     if (data?.data?.getMerchantVendorTransaction?.vendorsTransaction) {
  //       setRefetching(false);
  //       setTransactionData(
  //         data?.data?.getMerchantVendorTransaction?.vendorsTransaction,
  //       );
  //     }
  //   } catch (error) {
  //     if (error instanceof Error) {
  //       console.log(error.message);
  //     } else {
  //       console.log(error);
  //     }
  //     setRefetching(false);
  //     refetch({
  //       endDate: end_date,
  //       startDate: start_date,
  //       page: currentPage,
  //       limit: itemsPerRow.name,
  //     });
  //   }
  // };

  // useEffect(() => {
  //   refetchDataFetch({
  //     start_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.startDate)
  //       : startDate,
  //     end_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.endDate)
  //       : endDate,
  //     status: status?.toUpperCase(),
  //     vendor_id: schoolId === "" ? "" : schoolId,
  //   });
  // }, [status, schoolId, itemsPerRow, currentPage]);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  const GET_VENDOR_TRANSACTION_AMOUNT = async (
    start_date: string,
    end_date: string,
    trustee_id: string,
    school_ids: string[],
    status: string,
    vendor_id?: string | null,
    mode?: string[] | null,
    gateway?: string[] | null,
  ) => {
    const token = localStorage.getItem("token");
    axios
      .post(
        `${process.env.REACT_APP_PAYMENT_BACKEND_URL}/edviron-pg/get-vendor-transaction-report-batched`,
        {
          trustee_id,
          school_ids,
          start_date,
          end_date,
          status,
          vendor_id,
          mode,
          gateway,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        setVendorAmountDetails(response.data.transactions[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GET_VENDOR_TRANSACTION_AMOUNT(
      isDateRangeIsSelected &&
        selectedRange?.startDate &&
        selectedRange?.endDate
        ? formatDate(selectedRange.startDate)
        : startDate,
      isDateRangeIsSelected &&
        selectedRange?.startDate &&
        selectedRange?.endDate
        ? formatDate(selectedRange.endDate)
        : endDate,
      user?.getMerchantQuery?.trustee_id,
      Array.isArray(user?.getMerchantQuery?.school_id)
        ? user.getMerchantQuery.school_id
        : [user?.getMerchantQuery?.school_id].filter(Boolean),
      status ? status.toUpperCase() : "SUCCESS",
      filters.vendor_id ? filters.vendor_id : undefined,
      getPaymentMode(filters.paymentMode, type),
      getPaymentMode(filters.gateway, type),
    );
  }, [
    type,
    status,
    filters,
    filters.vendor_id,
    filters.paymentMode,
    filters.gateway,
    selectedRange,
    isDateRangeIsSelected,
    startDate,
    endDate,
    schoolId,
  ]);
  return (
    <div>
        <>
          <h2 className="text-[#1B163B] text-[28px]  font-semibold">
            Vendor Transactions
          </h2>
          <div className="w-full grid xl:grid-cols-2 gap-4 mb-2">
            <div className="xl:col-span-1 col-span-2">
              <h2 className="text-[#1B163B] xl:text-[24px] text-lg ml-2 font-normal">
                Transaction Amount
              </h2>
              <div className="text-[#229635] font-normal flex items-center">
                <span className="xl:text-[44px] text-3xl flex items-center">
                  <LiaRupeeSignSolid />
                  {vendorAmountDetails !== null &&
                  (status?.toLowerCase() === "success" || status === null) ? (
                    <span>
                      {vendorAmountDetails?.totalTransactionAmount?.toLocaleString(
                        "hi-in",
                      )}
                    </span>
                  ) : (
                    <span>0</span>
                  )}
                </span>
                <span className="text-[20px] text-[#717171] flex items-center ml-2">
                  {` (selected period )`}
                </span>
              </div>
            </div>

            <div className="xl:col-span-1 col-span-2">
              <h2 className="text-[#1B163B] xl:text-[24px] text-lg ml-2 font-normal">
                Vendor Amount
              </h2>
              <div className="text-[#229635] font-normal flex items-center">
                <span className="xl:text-[44px] text-3xl flex items-center">
                  <LiaRupeeSignSolid />
                  {vendorAmountDetails !== null &&
                  (status?.toLowerCase() === "success" || status === null) ? (
                    <span>
                      {vendorAmountDetails?.totalOrderAmount?.toLocaleString(
                        "hi-in",
                      )}
                    </span>
                  ) : (
                    <span>0</span>
                  )}
                </span>
                <span className="text-[20px] text-[#717171] flex items-center ml-2">
                  {` (selected period )`}
                </span>
              </div>
            </div>
          </div>
          <Table
            perPage={false}
            exportBtn={true}
            heading={"Vendor Transactions"}
            copyContent={[5]}
            srNo={false}
            filter={[searchText]}
            loading={loading}
            isCustomFilter={true}
            searchBox={
              <div className="w-full ">
                <div className="flex xl:!flex-row flex-col justify-between gap-2  w-full xl:items-center items-start mb-2">
                  <div className="bg-[#EEF1F6] py-3 items-center flex  px-3 xl:max-w-md max-w-[34rem] w-full rounded-lg">
                    <input
                      className="text-xs pr-2 bg-transparent focus:outline-none w-full placeholder:font-normal"
                      type="text"
                      value={searchText}
                      placeholder="Search(Order ID...)"
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    {searchFilter !== "" && searchText.length > 3 && (
                      <HiMiniXMark
                        onClick={async () => {
                          setSearchFilter("");
                          setSearchText("");
                          setShouldSearch(false);
                          // refetchDataFetch({
                          //   start_date: startDate,
                          //   end_date: endDate,
                          // });
                        }}
                        className="text-[#1E1B59] cursor-pointer text-md mr-2 shrink-0"
                      />
                    )}
                    <Select
                      className="border-l-2 border-gray-400"
                      options={[
                        {
                          label: "By Order ID",
                          value: "custom_order_id",
                        },
                        { label: "By Edviron Order ID", value: "order_id" },
                      ]}
                      isSearchable={false}
                      components={{
                        DropdownIndicator: CustomDropdownIndicator,
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e: any) => {
                        setSearchFilter(e.value.toLowerCase());
                        setCurrentPage(1);
                      }}
                      placeholder={
                        <div className="text-[#1E1B59] -mt-1 capitalize text-[10px]">
                          {searchFilter === ""
                            ? "filter by"
                            : searchFilter
                                  .toString()
                                  .toLowerCase()
                                  .replaceAll("_", " ") === "order id"
                              ? "Edviron Order ID"
                              : searchFilter
                                  .toString()
                                  .toLowerCase()
                                  .replaceAll("_", " ")}
                        </div>
                      }
                      value={searchFilter}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: "transparent",
                          height: "20px",
                          border: "none",
                          boxShadow: "none",
                          cursor: "pointer",
                          minHeight: "10px",
                          padding: "0px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "20px",
                          width: "8rem",
                          padding: "0 8px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                          lineHeight: "20px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "20px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "20px",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          fontSize: "10px",
                          cursor: "pointer",
                        }),
                      }}
                    />

                    <div className="w-10 z-50 shrink-0 flex justify-center items-center">
                      {searchText.length > 3 && loading ? (
                        <AiOutlineLoading3Quarters className="text-xs animate-spin" />
                      ) : (
                        <IoSearchOutline
                          onClick={() => {
                            if (searchText.length > 3 && searchFilter !== "") {
                              setCurrentPage(1);
                              setShouldSearch(true);
                              // refetchDataFetch({
                              //   order_id:
                              //     searchFilter === "order_id" ? searchText : null,
                              //   custom_id:
                              //     searchFilter === "custom_order_id"
                              //       ? searchText
                              //       : null,
                              // });
                            }
                          }}
                          className=" cursor-pointer text-edvion_black text-opacity-50 text-md "
                        />
                      )}
                    </div>
                  </div>

                  <div className="flex justify-end items-center flex-1 w-full max-w-[34rem]">
                    <DateFilter
                      setType={setDateRange}
                      type={dateRange}
                      selectedRange={selectedRange}
                      setSelectedRange={setSelectedRange}
                      setIsDateRangeIsSelected={setIsDateRangeIsSelected}
                      refetch={() => {
                        setCurrentPage(1);
                      }}
                    />
                    <div className="w-full">
                      <Select
                        className="font-normal m-0 p-2 capitalize"
                        options={[
                          { label: "SUCCESS", value: "SUCCESS" },
                          { label: "PENDING", value: "PENDING" },
                          { label: "FAILED", value: "FAILED" },
                          { label: "USER DROPPED", value: "USER_DROPPED" },
                        ].map((status: any) => {
                          return {
                            label: status.label?.toLowerCase(),
                            value: status.value?.toLowerCase(),
                          };
                        })}
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                          IndicatorSeparator: () => null,
                        }}
                        onChange={(e: any) => {
                          setStatus(e.value);
                          setCurrentPage(1);
                          // refetchDataFetch({
                          //   start_date: isDateRangeIsSelected
                          //     ? formatDate(selectedRange.startDate)
                          //     : startDate,
                          //   end_date: isDateRangeIsSelected
                          //     ? formatDate(selectedRange.endDate)
                          //     : endDate,
                          //   status: e.value?.toUpperCase(),
                          //   // isCustomSearch: isCustomSearch,
                          //   // searchFilter: searchFilter,
                          //   // searchParams: searchText,
                          //   // school_id: selectSchool === "" ? null : schoolId,
                          //   payment_modes: getPaymentMode(
                          //     filters.paymentMode,
                          //     type,
                          //   ),
                          //   isQrCode: getPaymentMode(
                          //     filters.paymentMode,
                          //     type,
                          //   )?.includes("qr"),
                          //   gateway: getPaymentMode(filters.gateway, type),
                          // });
                        }}
                        placeholder={
                          <div className="text-[#1E1B59] text-xs">Status</div>
                        }
                        value={null}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            backgroundColor: "#F6F8FA",
                            border: "1px solid #1B163B",
                            borderRadius: "6px",

                            minHeight: "15px",
                            margin: "0px",
                            color: "#6687FF",
                          }),
                          valueContainer: (provided: any) => ({
                            ...provided,
                            padding: "0px",
                            paddingLeft: "0.5rem",
                          }),
                          input: (provided: any) => ({
                            ...provided,
                            backgroundColor: "transparent",
                            color: "#000",
                            "::placeholder": {
                              backgroundColor: "#YourDesiredColor",
                              opacity: 1,
                            },
                            placeholder: (provided: any) => ({
                              ...provided,
                              color: "red", // Set the color of the placeholder text
                            }),
                          }),
                        }}
                      />
                    </div>
                    <div className="w-full">
                      <MixFilter
                        setSelectSchool={settempSelectSchool}
                        setSchoolId={tempsetSchoolId}
                        paymentModes={Object.keys(
                          tempFilters.paymentMode,
                        ).filter((key) => tempFilters.paymentMode[key])}
                        setType={setType}
                        gateway={Object.keys(tempFilters.gateway).filter(
                          (key) => tempFilters.gateway[key],
                        )}
                        onCancel={() => {
                          // refetchDataFetch({
                          //   start_date: startDate,
                          //   end_date: endDate,
                          // });
                        }}
                        onApply={() => {
                          setCurrentPage(1);
                          setFilters(tempFilters);
                          setSelectSchool(tempselectSchool);
                          setSchoolId(tempschoolId);

                          // refetchDataFetch({
                          //   start_date: isDateRangeIsSelected
                          //     ? formatDate(selectedRange.startDate)
                          //     : startDate,
                          //   end_date: isDateRangeIsSelected
                          //     ? formatDate(selectedRange.endDate)
                          //     : endDate,
                          //   status: status?.toUpperCase(),
                          //   limit: itemsPerRow.toString(),
                          //   vendor_id: selectSchool === "" ? undefined : schoolId,
                          //   payment_modes: getPaymentMode(
                          //     filters.paymentMode,
                          //     type,
                          //   )?.includes("qr")
                          //     ? null
                          //     : getPaymentMode(filters.paymentMode, type),
                          //   isQrCode: getPaymentMode(
                          //     filters.paymentMode,
                          //     type,
                          //   )?.includes("qr"),
                          //   gateway: getPaymentMode(filters.gateway, type),
                          // });
                        }}
                        filters={tempFilters}
                        setFilters={setTempFilters}
                      />
                    </div>
                    {/* <div className="w-full">
                    <Institute
                      setSelectSchool={setSelectSchool}
                      setSchoolId={setSchoolId}
                    />
                  </div> */}
                  </div>
                </div>
                <div>
                  <RowsPerPageSelect
                    setItemsPerRow={setItemsPerRow}
                    itemsPerRow={itemsPerRow}
                    className=" justify-start"
                  />
                </div>
                <div className="flex items-center">
                  {type !== "" && (
                    <div className=" text-sm m-2  max-w-fit ">
                      <button
                        onClick={async () => {
                          // setSelectedRange({
                          //   startDate: startOfDay(new Date()),
                          //   endDate: endOfDay(new Date()),
                          //   key: "selection",
                          // });
                          setFilters({
                            paymentMode: {
                              credit_card: false,
                              credit_card_emi: false,
                              upi: false,
                              wallet: false,
                              pay_later: false,
                              cardless_emi: false,
                              net_banking: false,
                              debit_card_emi: false,
                              debit_card: false,
                              na: false,
                              qr: false,
                            },
                            gateway: {
                              EDVIRON_PG: false,
                              EDVIRON_EASEBUZZ: false,
                              EDVIRON_RAZORPAY: false,
                            },
                            vendor_id: undefined,
                          });
                          setTempFilters({
                            paymentMode: {
                              credit_card: false,
                              credit_card_emi: false,
                              upi: false,
                              wallet: false,
                              pay_later: false,
                              cardless_emi: false,
                              net_banking: false,
                              debit_card_emi: false,
                              debit_card: false,
                              na: false,
                              qr: false,
                            },
                            gateway: {
                              EDVIRON_PG: false,
                              EDVIRON_EASEBUZZ: false,
                              EDVIRON_RAZORPAY: false,
                            },
                          });
                          setType("");
                          // if (status || schoolId) {
                          //   setType("");
                          //   refetchDataFetch({
                          //     start_date: startDate,
                          //     end_date: endDate,
                          //     status: status?.toUpperCase(),
                          //     vendor_id: schoolId === "" ? "" : schoolId,
                          //   });

                          // } else {
                          //   refetchDataFetch({
                          //     start_date: startDate,
                          //     end_date: endDate,
                          //   });
                          //   setType("");
                          // }
                        }}
                        className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                      >
                        {type} <HiMiniXMark className=" text-lg ml-1" />
                      </button>
                    </div>
                  )}
                  {dateRange !== "" && dateRange !== "Today" && (
                    <div className=" text-sm m-2  max-w-fit ">
                      <button
                        onClick={async () => {
                          setCurrentPage(1);
                          setSelectedRange({
                            startDate: startOfDay(new Date()),
                            endDate: endOfDay(new Date()),
                            key: "selection",
                          });
                          setIsDateRangeIsSelected(false);
                          setDateRange("");
                          // if (status || schoolId) {
                          //   refetchDataFetch({
                          //     start_date: startDate,
                          //     end_date: endDate,
                          //     status: status?.toUpperCase(),
                          //     vendor_id: schoolId === "" ? "" : schoolId,
                          //   });
                          //   setDateRange("");
                          //   setIsDateRangeIsSelected(false);
                          // } else {
                          //   refetchDataFetch({
                          //     start_date: startDate,
                          //     end_date: endDate,
                          //   });
                          //   setDateRange("");
                          //   setIsDateRangeIsSelected(false);
                          // }
                        }}
                        className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                      >
                        {dateRange} <HiMiniXMark className=" text-lg ml-1" />
                      </button>
                    </div>
                  )}
                  {selectSchool !== "" && (
                    <div className=" text-sm m-2  max-w-fit ">
                      <button
                        onClick={() => {
                          setCurrentPage(1);
                          setSchoolId("");
                          tempsetSchoolId("");
                          settempSelectSchool("");
                          setSelectSchool("");
                          // if (status || isDateRangeIsSelected || type) {
                          //   refetchDataFetch({
                          //     start_date: isDateRangeIsSelected
                          //       ? formatDate(selectedRange.startDate)
                          //       : startDate,
                          //     end_date: isDateRangeIsSelected
                          //       ? formatDate(selectedRange.endDate)
                          //       : endDate,
                          //     status: status?.toUpperCase(),
                          //     vendor_id: schoolId,
                          //   });

                          //   setSelectSchool("");
                          //   setSchoolId("");
                          // } else {
                          //   refetchDataFetch({
                          //     start_date: startDate,
                          //     end_date: endDate,
                          //   });
                          //   setSelectSchool("");
                          //   setSchoolId("");
                          // }
                        }}
                        className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                      >
                        {selectSchool} <HiMiniXMark className=" text-lg ml-1" />
                      </button>
                    </div>
                  )}
                  {status && (
                    <div className=" text-sm m-2  max-w-fit ">
                      <button
                        onClick={async () => {
                          setCurrentPage(1);
                          setStatus(null);
                          // if (selectSchool || isDateRangeIsSelected) {
                          //   refetchDataFetch({
                          //     start_date: isDateRangeIsSelected
                          //       ? formatDate(selectedRange.startDate)
                          //       : startDate,
                          //     end_date: isDateRangeIsSelected
                          //       ? formatDate(selectedRange.endDate)
                          //       : endDate,
                          //     payment_modes: getPaymentMode(
                          //       filters.paymentMode,
                          //       type,
                          //     ),
                          //     isQrCode: getPaymentMode(
                          //       filters.paymentMode,
                          //       type,
                          //     )?.includes("qr"),
                          //     gateway: getPaymentMode(filters.gateway, type),
                          //     // school_id: schoolId === "" ? "" : schoolId,
                          //   });
                          //   setStatus(null);
                          // } else {
                          //   refetchDataFetch({
                          //     start_date: startDate,
                          //     end_date: endDate,
                          //     payment_modes: getPaymentMode(
                          //       filters.paymentMode,
                          //       type,
                          //     ),
                          //     isQrCode: getPaymentMode(
                          //       filters.paymentMode,
                          //       type,
                          //     )?.includes("qr"),
                          //     gateway: getPaymentMode(filters.gateway, type),
                          //   });
                          //   setStatus(null);
                          // }
                        }}
                        className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                      >
                        {status} <HiMiniXMark className=" text-lg ml-1" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            }
            data={[
              [
                "Sr.No",
                "Name",
                "School name",
                "Date & Time",
                "Order ID",
                "Transaction Amt",
                "Vendor Order Amt",
                "Payment Method",
                "Status",
                "Student Name",
                "Student Id",
                "Gateway",
              ],
              ...([
                ...transactionData?.map((d: any, index: number) => {
                  return {
                    ...d,
                    payment_method:
                      d.payment_method === "" || d.payment_method === null
                        ? "NA"
                        : payment_method_map[d.payment_method],
                    serialNumber:
                      (currentPage - 1) * itemsPerRow.name + 1 + index,
                  };
                }),
              ]
                // .filter((d: any) => {
                //   const arr = [
                //     d.collect_id,
                //     d.custom_id,
                //     d.school_id,
                //     d.name,
                //   ].join(",");
                //   return arr.toLowerCase().includes(searchText.toLowerCase());
                // })
                .map((transaction: any, index: number) => [
                  <div>{transaction?.serialNumber}</div>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div
                      // onClick={(e) => {
                      //   console.log(transaction)
                      //   // e.preventDefault(); // Prevents any unwanted navigation issues
                      //   // handelReciept(transaction); // Correctly passing the transaction object
                      // }}
                      className="truncate"
                      key={transaction.orderID}
                    >
                      {transaction?.name}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div className="truncate">
                      {transaction?.schoolName || "N/A"}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>
                      {new Date(transaction?.createdAt).toLocaleString("hi")}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>
                      {transaction.custom_order_id
                        ? transaction?.custom_order_id
                        : transaction?.collect_id}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>{amountFormat(transaction.transaction_amount)}</div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>{amountFormat(transaction.amount)}</div>
                  </Link>,

                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>
                      {transaction.payment_method !== null
                        ? transaction?.payment_method?.replace(/_/g, " ")
                        : "N/A"}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div
                      className={`flex items-center capitalize ${
                        transaction.status.toLowerCase() === "success"
                          ? "text-[#04B521]"
                          : transaction.status.toLowerCase() === "failure" ||
                              transaction.status.toLowerCase() === "failed"
                            ? "text-[#E54F2F]"
                            : transaction.status.toLowerCase() === "pending"
                              ? "text-yellow-400"
                              : transaction.status.toLowerCase() ===
                                  "USER_DROPPED"
                                ? "text-yellow-400"
                                : ""
                      }`}
                    >
                      {transaction.status.replace(/_/g, " ")}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>
                      {(() => {
                        try {
                          return (
                            JSON.parse(transaction?.additional_data)
                              ?.student_details?.student_name || "N/A"
                          );
                        } catch (error) {
                          return "N/A";
                        }
                      })()}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>
                      {(() => {
                        try {
                          return (
                            JSON.parse(transaction?.additional_data)
                              ?.student_details?.student_id || "N/A"
                          );
                        } catch (error) {
                          return "N/A";
                        }
                      })()}
                    </div>
                  </Link>,
                  <Link
                    state={getVendorReceiptState(transaction)}
                    to={`/payments/vendor-transaction-receipt`}
                  >
                    <div>
                      {transaction.gateway === "EDVIRON_PG"
                        ? "Cashfree"
                        : transaction.gateway}
                    </div>
                  </Link>,
                ]) || []),
            ]}
            footer={
              <div className="flex justify-center items-center">
                <Pagination
                  currentPage={currentPage}
                  totalPages={TotalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            }
          />
        </>
    </div>
  );
}

export default VendorTransaction;
